<template>
  <div class="p20">
    <h1>Menu Management</h1>
    <!-- Add your menu management components here -->
  </div>
</template>

<script>
export default {
  name: 'MenuIndex',
  components: {},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

</style>